import {Input} from "antd";
import "./big-input.css";

interface BigInputProps {
    name?: string;
    value: string;
    setValue: (newVal: string) => void;
    placeholder?: string;
    description?: string;
    className?: string;
    maxLength?: number;
    type?: 'text' | 'number';
    isDisabled?: boolean;
    sign?: string;
    containerClassName?: string;
    direction?: 'rtl' | 'ltr';
    required?: boolean;
}

export const BigInput = ({ name = '', direction = 'ltr', containerClassName = '', type = 'text', value, setValue, placeholder = '', description = '', className = '', maxLength, isDisabled = false, sign, required = false }: BigInputProps) => {
    return (
        <div className={`field-container ${containerClassName || ''}`}>
            <div className={`input-container ${sign ? 'with-sign' : ''}`}>
                {sign ? <div className="big-input-sign">{sign}</div> : null}
                {required ? <div className="required-icon">*</div> : null}
                <Input disabled={isDisabled} type={type} value={value} className={`big-input ${className}`} onChange={(event) => setValue(event.target.value)} placeholder={placeholder} maxLength={maxLength} style={{ direction }} />
            </div>
            {description && <div className="description">
                {description}
            </div>}
        </div>
    );
}